import React from "react";
import { 
    selectWaterTreatment,
    selectDischargeFilter, 
    selectDischargeStrainer, 
    selectInletScreen, 
    selectInletStrainer, 
    selectRo, 
    selectUv 
} from "../../../redux/selectors";
import { useSelector } from "react-redux";

const PrintWaterTreatment = ({ zone }) => {
  const waterTreatment = useSelector(selectWaterTreatment);
  const inletFilterDetails = useSelector(selectInletScreen);
  const inletStrainerDetails = useSelector(selectInletStrainer);
  const dischargeFilterDetails = useSelector(selectDischargeFilter);
  const dischargeStrainerDetails = useSelector(selectDischargeStrainer);
  const roDetails = useSelector(selectRo);
  const uvDetails = useSelector(selectUv);

  const filterByZone = (details) => {
    return details && details.filter(detail => detail.zone === zone);
  };

  // Check if HasFilters is true for the current zone - this is the main prerequisite
  const hasFilters = waterTreatment?.some(detail => detail.zone === zone && detail.HasFilters);
  
  // Only check individual section filters if HasFilters is true
  const hasSection = (flag, details) =>
    hasFilters && 
    waterTreatment?.some(detail => detail.zone === zone && detail[flag]) &&
    filterByZone(details)?.length > 0;
  

  const renderSection = (details, sectionName, fields, has) => {
    if (!details || details.length === 0) {
      return null;
    }

    return (
<div className="section">
        <h3 className="print-zone-label text-center">{sectionName}</h3>
        <table className="table table-bordered full-width">
          <tbody>
            <tr>
              <td className="col-md-6">
                <table>
                  <tbody>
                    {fields.slice(0, Math.ceil(fields.length / 2)).map((field, index) => (
                      <tr key={index}>
                        <td><strong>{field.label}: </strong>{details[0][field.key]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </td>
              <td className="col-md-6">
                <table>
                  <tbody>
                    {fields.slice(Math.ceil(fields.length / 2)).map((field, index) => (
                      <tr key={index}>
                        <td><strong>{field.label}: </strong>{details[0][field.key]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>)
    };

    const sections = [
      {
        name: "Inlet Filter",
        has: hasSection("HasInletFilter", inletFilterDetails),
        details: filterByZone(inletFilterDetails),
        fields: [
          { label: "Flume Pipe Size", key: "InletFlumePipeSize" },
          { label: "Flume Type", key: "FilterFlumeType" },
          { label: "Manufacturer", key: "FilterManufacturer" },
          { label: "Filter Type", key: "InletFilterType" },
          { label: "Filter Model", key: "InletFilterModel" },
          { label: "Screen Size", key: "InletScreenSize" },
          { label: "Comments", key: "InletFilterComments" },
        ],
      },
      {
        name: "Inlet Strainer",
        has: hasSection("HasInletStrainer", inletStrainerDetails),
        details: filterByZone(inletStrainerDetails),
        fields: [
          { label: "Manufacturer", key: "Manufacturer" },
          { label: "Type / Size", key: "TypeSize" },
          { label: "Quantity", key: "Quantity" },
          { label: "Comments", key: "InletStrainerComments" },
        ],
      },
      {
        name: "Discharge Filter",
        has: hasSection("HasDischargeFilter", dischargeFilterDetails),
        details: filterByZone(dischargeFilterDetails),
        fields: [
          { label: "Quantity", key: "Quantity" },
          { label: "Manufacturer", key: "Manufacturer" },
          { label: "Type", key: "Type" },
          { label: "Model", key: "Model" },
          { label: "Future Filters", key: "FutureFilters" },
          { label: "Filter Mesh Size", key: "FilterMeshSize" },
          { label: "Bypass", key: "Bypass" },
          { label: "Filter Flush Type", key: "FilterFlushType" },
          { label: "Comments", key: "DischargeFilterComments" },
        ],
      },
      {
        name: "Discharge Strainer",
        has: hasSection("HasWyeStrainer", dischargeStrainerDetails),
        details: filterByZone(dischargeStrainerDetails),
        fields: [
          { label: "Manufacturer", key: "Manufacturer" },
          { label: "Type / Size", key: "TypeSize" },
          { label: "Quantity", key: "Quantity" },
          { label: "Comments", key: "DischargeStrainerComments" },
        ],
      },
      {
        name: "RO",
        has: hasSection("HasRO", roDetails),
        details: filterByZone(roDetails),
        fields: [
          { label: "Model", key: "Model" },
          { label: "Quantity", key: "Quantity" },
          { label: "Comments", key: "Comments" },
        ],
      },
      {
        name: "UV",
        has: hasSection("HasUV", uvDetails),
        details: filterByZone(uvDetails),
        fields: [
          { label: "Model", key: "Model" },
          { label: "Quantity", key: "Quantity" },
          { label: "Comments", key: "Comments" },
        ],
      },
    ];
    
    // If HasFilters is false, don't render anything
    if (!hasFilters) {
      return null;
    }

    // Only check if any sections exist if HasFilters is true
    const hasAnySection = sections.some(section => section.has);

    if (!hasAnySection) {
      return null;
    }

  return (
    <div>
      <h2 className="print-section-header">Water Treatment Summary</h2>
      {sections.map((section, index) => (
        section.has && renderSection(section.details, section.name, section.fields)
      ))}
    </div>
  );
};

export default PrintWaterTreatment;
